import type { ImgHTMLAttributes } from "react";
import styles from "./Logo.module.css";
import { cx } from "./cx.js";

type LogoProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt">;

/**
 * The squirrel mark on its own. Every place it appears sets "Squirrel" in text
 * beside it, so it is decorative — an alt here would only say the word twice.
 *
 * Served from `public/` rather than inlined: it is a few thousand path nodes,
 * and none of them need to change with the theme.
 */
export function Logo({ className, ...rest }: LogoProps) {
  return (
    <img
      src="/squirrel-logo.svg"
      alt=""
      className={cx(styles.logo, className)}
      draggable={false}
      {...rest}
    />
  );
}
